import { IApplicationState, TBoardId, TFilterId } from '../../../../../../../../types/types';
import { savedFilterSelector } from '../../../../store/selectors/savedFilterSelector';
import { getSortedSavedFiltersIds } from './getSortedSavedFiltersIds';

export const getPinnedSavedFiltersIds = (
    state: IApplicationState,
    boardId: TBoardId
): TFilterId[] => {
    const filtersIds = getSortedSavedFiltersIds(state, boardId);
    return filtersIds.reduce((filterIds, filterId) => {
        const filter = savedFilterSelector(state, filterId);
        if (filter && filter.meta && filter.meta.isPinned) {
            filterIds.push(filterId);
        }
        return filterIds;
    }, []);
}
